export const customerSchema = {
  _id: '',
  firstName: '',
  lastName: '',
  fullName: '',
  companyName: '',
  fullNameQBO: '',
  phone: '',
  email: '',
  phone2: '',
  notes: '',
  externalId: '',
  isFleetCustomer: false,
  taxExempt: false,
  contactOnEmail: false,
  contactOnPhone: false,
  isActive: false,
  chargeAccountEnable: false,
  preferredLanguage: 'EN',
  chargeAccountDetails: {
    allowedLimit: '200',
    usedLimit: '500',
    unlimited: true,
  },
  preferredLocation: {
    name: '',
    locationId: '',
  },
  address: {
    addLine1: '',
    addLine2: '',
    city: '',
    state: '',
    zip: '',
    stateCode: '',
    country: '',
  },
  taxExemptReason: {},
  customerType: { label: 'Regular', value: 'regular' },
  businessAddress: {
    addLine1: '',
    addLine2: '',
    city: '',
    state: '',
    zip: '',
    stateCode: '',
    country: '',
  },
  tags: [],
  isMFCustomer: false,
  fleetNumber: '',
  accountType: '',
  openFromMFC: false,
  isMarketingNotifEnabled: false,
  isOperationalNotifEnabled: false,
};
